/**
 * List of targets (records in database) whose changes should be tracked
 */
export enum USER_ACTION_TARGET {
    EXAMINATION,
    PATIENT,
    USER,
    SETTINGS,
}
